import { twAutoCols } from './style/autoCols'
import type { GridAutoColTypes } from './style/types'

export const getAutoColsClasses = (options: GridAutoColTypes) => {
  return twAutoCols[options]
}
